<template>
  <div class="home">
    <!-- Hero Area Start -->
      <div id="home-slider" class="container-fluid no-padding ">
          <SliderCmp />
      </div>

    <!-- TELEHEALTH -->
    <div class="about-area section-padding ">
      <div class="container-fluid ">
        <div class="row">
         <div class="col-lg-4 col-md-6  col-xs-12 wow fadeInRight" data-wow-delay="0.3s">
                <img class="img-fluid" src="../assets/img/v2/telemedicine.svg" alt="" >
         </div>
          <div class="col-lg-8 col-md-6 col-xs-12 info">
            <div class="about-wrapper wow fadeInLeft" data-wow-delay="0.3s">
              <div>
                <div class="site-heading">
                  <h1 class="">{{$t('telehealth.title')}}</h1>
                  <h2 class="section-title">{{$t('telehealth.subTitle')}}</h2>
                </div>
                <div class="content">
                  <p>{{$t('telehealth.txt1')}}</p>
                  <p>{{$t('telehealth.txt2')}}</p>
                  <p>{{$t('telehealth.txt3')}}</p>
                  <!--                    <a href="#" class="btn btn-common mt-3">Read More</a>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- TELEHEALTH Section End -->

    <!-- MENTAL ILLNESS -->
    <div class="about-area section-padding bg-gray">
      <div class="container-fluid ">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-xs-12 info text-left">
            <div class="about-wrapper collapsed wow fadeInLeft" data-wow-delay="0.3s">
              <div>
                <div class="site-heading" v-on:click="expand1 = !expand1">
                  <a class="section-title"  v-b-toggle href="#mentalillness-collapse" @click.prevent>
                    <i class="fa fa-question-circle "></i><span>{{$t('mentalillness.title')}}</span>
                    <i class="fa " v-bind:class="{ 'fa-angle-down': !expand1 , 'fa-angle-up': expand1 }"></i></a>
<!--                  <h2 class="section-title">{{$t('mentalillness.subTitle')}}</h2>-->
                </div>
                <b-collapse id="mentalillness-collapse" class="text-justify" >
                  <div class="content">
                    <p>{{$t('mentalillness.txt1')}}</p>
                    <p>{{$t('mentalillness.txt2')}}</p>
                    <p>{{$t('mentalillness.txt3')}}</p>
                    <!--                    <a href="#" class="btn btn-common mt-3">Read More</a>-->
                  </div>
                </b-collapse>

              </div>
            </div>
          </div>
          <div style="margin-top: 25px" class="col-lg-12 col-md-12 col-xs-12 info text-left" >
            <div class="about-wrapper collapsed wow fadeInRight" data-wow-delay="0.4s">
              <div style="vertical-align: inherit;">
                <div class="site-heading" v-on:click="expand2 = !expand2">
                  <a class="section-title"  v-b-toggle href="#mentalillness-therapy-collapse" @click.prevent>
                    <i class="fa fa-question-circle "></i>
                    <span>{{$t('mentalillness.therapy.title')}}</span>
                    <i class="fa " v-bind:class="{ 'fa-angle-down': !expand2 , 'fa-angle-up': expand2 }"></i></a>
<!--                  <h2 class="section-title">{{$t('mentalillness.therapy.title')}}</h2>-->
                  <!--                  <h2 class="section-title">{{$t('mentalillness.subTitle')}}</h2>-->
                </div>
                <b-collapse id="mentalillness-therapy-collapse" class="text-justify" >
                  <div class="content">
                    <p>{{$t('mentalillness.therapy.txt1')}}</p>
                    <p>{{$t('mentalillness.therapy.txt2')}}</p>
                    <p>{{$t('mentalillness.therapy.txt3')}}</p>
                    <!--                    <a href="#" class="btn btn-common mt-3">Read More</a>-->
                  </div>
                </b-collapse>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- About Section End -->
  </div>
</template>

<script>
  import SliderCmp from '../components/SliderCmp'
  export default {
    name: "Home",
      components: {
          SliderCmp
      },
    data: function () {
      return {
        expand1: false,
        expand2: false
      }
    }
  }
</script>

<style lang="scss">

</style>
